/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-surface': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M1.5.75V.38A.38.38 0 011.88 0h3a.38.38 0 01.37.38v.37zm10.5 12H5.25V6H1.5v10.12a.38.38 0 00.38.38H12zm5.62 0h-.37v3.75h.37a.38.38 0 00.38-.38v-3a.38.38 0 00-.38-.37zM16.12 1.5H.38a.38.38 0 00-.38.38v3a.38.38 0 00.38.37h12.37v12.37a.38.38 0 00.37.38h3a.38.38 0 00.38-.38V1.88a.38.38 0 00-.38-.38zm-2.73 11.89a.37.37 0 000-.53L5.14 4.61a.37.37 0 00-.53.53l8.25 8.25a.38.38 0 00.26.11.39.39 0 00.27-.11z"/>'
  }
})
